import { Page } from '@/core/architecture'

import { ConsoleMyProfileEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleMyProfileEdit Page
 * Implemented as a practical sample.
 */
export const ConsoleMyProfileEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleMyProfileEditTemplate state={state} {...actions} />
}
